// extracted by mini-css-extract-plugin
export default {"bullet_text":"fsp-bullet_text"};